import { html } from 'lit-element';
import {
  choiceValueStyles,
  bubbleStyles,
  responseStyles,
  correctnessIndicatorStyles,
} from '../cssUtils.js';
import { getPart, renderBubble } from '../utils.js';
import { CustomLitElement } from '../CustomLitElement.js';
import {
  defineElement,
  importMathRendering,
} from '../classroom-tool-extensions/classifier/utils.js';
import { PieMathRenderer } from '../classroom-tool-extensions/common/PieMathRenderer.js';

/**
 * @element multiple-choice-response
 * @prop {Object} model - The model for the pie
 * @prop {Object} session - The response session
 * @cssprop --pie-live-session-background-color - change the background color
 * @cssprop --pie-live-session-text-color - change the text color
 * @cssprop --pie-live-session-bubble-text-color - change the text color
 * @cssprop --pie-live-session-font-family - change the font family
 * @cssprop --pie-live-session-font-size-large - change the font size
 * @cssprop --pie-live-session-response-height - change the height (must be valid, eg: 100px, 10em )
 * @cssprop --pie-live-session-response-width - change the width (must be valid, eg: 100px, 10em )
 */
export class MultipleChoiceResponse extends CustomLitElement {
  static get properties() {
    return {
      model: { type: Object, attribute: false },
      session: { type: Array, attribute: false },
      hoveredChoice: { type: Object },
    };
  }

  set hoveredChoice(val) {
    const oldVal = this._hoveredChoice;

    if (!oldVal || !val || oldVal.value !== val.value) {
      this._hoveredChoice = val;
      this.requestUpdate('hoveredChoice', oldVal);
    }
  }

  get hoveredChoice() {
    return this._hoveredChoice;
  }

  constructor() {
    super();
    this._hoveredChoice = null;
  }

  createRenderRoot() {
    return this;
  }

  updated(_changedProperties) {
    super.updated(_changedProperties);

    defineElement('math-rendering-element', PieMathRenderer);

    if (!this.mathRenderingModuleUrlImported) {
      importMathRendering();

      this.mathRenderingModuleUrlImported = true;
    }
  }

  mouseover(e, value) {
    const item = e.target.closest('.choice-value');

    if (item && item.getBoundingClientRect) {
      const bounds = item.getBoundingClientRect();

      this.hoveredChoice = {
        value,
        top: bounds.top + bounds.height,
        left: bounds.left + bounds.width,
      };
    }
  }

  mouseout() {
    this.hoveredChoice = null;
  }

  render() {
    return html` <style>
        ${bubbleStyles}
          ${choiceValueStyles}
          ${correctnessIndicatorStyles}
          ${responseStyles}
          .multiple-choice-response.response {
          align-items: center;
          justify-content: center;
        }
        .multiple-choice-response span {
          line-height: 2;
          display: flex;
        }
        .multiple-choice-response .correctness-indicator {
          line-height: 1;
          margin-left: -4px;
        }
      </style>
      <div class="response multiple-choice-response">
        <span>
          ${getPart(this.model, this.session, {
            mouseover: this.mouseover.bind(this),
            mouseout: this.mouseout.bind(this),
          })}
        </span>
        ${renderBubble(this.hoveredChoice)}
      </div>`;
  }
}

export default MultipleChoiceResponse;
